<div class="back-container">
    <div class="back" routerLink="/">
        <div class="back-icon" src="assets/icons/user-plus.svg"></div>
        <div class="back-text">Connexion</div>
    </div>
</div>
<form [formGroup]="forgotPasswordForm" class="login-card-content" (ngSubmit)="onSubmit()">
    <div class="inputs-container">
        <frg-form-input placeholder="exemple@gmail.com" label="Adresse email" id="login"
            errorMessage="Veuillez entrer une adresse email valide" type="text" [formGroup]="forgotPasswordForm"
            [control]="forgotPasswordForm.get('login')" required="true"></frg-form-input>
    </div>
    <div class="captcha-container">
        <re-captcha (resolved)="resolved($event)" [siteKey]="recaptchaSiteKey"></re-captcha>
    </div>
    <div class="buttons-container">
        <div class="connect-button-container">
            <button type="submit" class="button">
                Récupération de votre mot de passe
                <div class="icon-container">
                    <div class="icon">
                    </div>
                </div>
            </button>
        </div>
    </div>
    <!-- <div class="error-container login-error" [ngClass]="{'no-height': !errorLogin}">
        Identifiants incorrects
    </div> -->
</form>